<template>
<div>
	<v-card height="500">
		<v-toolbar flat class="slimtoolbarBD">			
			<v-layout row align-center>
			<v-toolbar-title class="text-uppercase"> {{building.bldgAlpha}} - {{building.name}} </v-toolbar-title>
			
			<v-spacer></v-spacer>
			
    		<v-toolbar-items >
    			<v-tooltip top >
					<DeleteAllRoomsDialog v-if="isSuperUser" :icon="'delete'" slot="activator"  />
					<span>Delete All Rooms and Floors</span>
				</v-tooltip>
    			<v-tooltip top>
    				<v-btn icon slot="activator" 
									@click="gotoRoomViewer">
									<v-icon color="grey darken-3">line_style</v-icon>
								</v-btn>
								<span>Launch RoomViewer</span>
    			</v-tooltip>
				<v-tooltip top >
					<EditBuildingDialog v-if="isSuperUser" :newBldg="true" :icon="'add_circle_outline'" slot="activator"  />
					<span>Add New Building</span>
				</v-tooltip>
		
				<v-tooltip top>
					<EditBuildingDialog v-if="isSuperUser" :icon="'edit'" slot="activator"  />
					<span>Edit Building</span>
				</v-tooltip>

			</v-toolbar-items>
		</v-layout>
		</v-toolbar>
		<v-layout row fill-height>
			
			<v-flex xs7 class="px-3">
				<v-data-table :items="forcedArray" hide-actions hide-headers 
					class="ml-2 mt-3 bldgTable">
					<template slot="items" slot-scope="props">
						<tr v-for="(key, index) in Object.keys(props.item)" :index="index">
							<td width="100px"> {{key}} 	</td>
					        <td class="text-xs-right">{{ props.item[key] }}</td>
						</tr>
						
					</template>
		  		</v-data-table>
	  		</v-flex>
	  		<v-flex xs5 class="">
				<img ref="imgRef" align="right" :width="$vuetify.breakpoint.width > 1920 ? '70%' : '95%' " :src=building.photoURLMedium  @error="imgHandler" onLoad="style.visibility='visible'">
			</v-flex>
	  	</v-layout>

	</v-card>
</div>
</template>

<script>
import { mapState } from 'vuex'
import EditBuildingDialog from './EditBuildingDialog'
import DeleteAllRoomsDialog from './DeleteAllRoomsDialog'

export default {
name: 'TEMPLATE',
data () {
	return {
		showEditBuildingDialog: false,
        fieldsToShow: 	[ 'address', 'city', 'state', 'zip', 'resCode', 'historic', 'dateBuildingAdj', 'dateConstructed',
        				  'ownershipDescLong', 'planAreaDescLong', 'comment', 'status', 'grossArea', 'assignableArea', 
        				  'nonAssignableArea', 'useableArea',
        				  'restricted', 'capacity', 'uniqueOccupantCount', 'PICount', 
        				]
	}
},

components: { EditBuildingDialog, DeleteAllRoomsDialog, },

computed: {
	...mapState({   	building: state => state.dv.building,
						isSuperUser: state => state.user.isSuperUser,
				}),

	buildingItems: function () {
		if (this.building) {
		return 	[
					{ label: 'Number', val: (this.building.id) + " / " + this.building.bldgAlpha },
					{ label: 'Address', val: this.building.address },
					{ label: 'Gross SF', val: this.building.grossArea.toLocaleString(undefined, { maximumFractionDigits: 0 }) },
					{ label: 'Assignable SF', val: this.building.netAssignableSF.toLocaleString(undefined, { maximumFractionDigits: 0 }) },
				]
		}
	},

	forcedArray: function () {		
		const filtered = Object.keys(this.building)
			  .filter(key => this.fieldsToShow.includes(key))
			  .reduce((obj, key) => {
			    obj[key] = this.building[key];
			    return obj;
			  }, {});
		let fa = []
		fa.push( filtered )
		return fa
	}
},

methods : {
    addNewBuilding: function () {
    	this.showEditBuildingDialog = true
    },

    imgHandler: function (e) {
    	this.$refs.imgRef.style.visibility = "hidden"
    	console.log("Image Error")
    },
    gotoRoomViewer() {
			console.log("Launch Roomviewer")
			this.$router.push({ name: 'RoomViewerToBldg', params: { rvbldg: this.building.bldgAlpha }})
	},

},
}

</script>

<style>
.bldgTable {
		height: calc(100% - 80px) !important; 
		overflow-y: auto;
}

/* this technique gets deeply nested th td selectors */
.bldgTable th { padding-left: 20px !important; }
.bldgTable td { padding-left: 0px !important; height: 10px !important;}
.bldgTable .v-table__overflow { 
	overflow-x: unset !important;
	overflow-y: unset !important;
 }

 .bldgTable .table {
 	padding-left: 30px;
 	border-radius: 0px;
 }

 .slimtoolbarBD > .v-toolbar__content {
	height: 40px !important;
	padding-right: 0px;
}


</style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/BuildingDetail.vue